import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import Style from './index.module.less'

export default class extends Component {
  render() {
    return (
      <HeaderView>
        <div className={Style.content}>
          <img src="//qnm.hunliji.com/o_1dedsagotvfp7cq151a13memilk.png" />
          <img src="//qnm.hunliji.com/o_1dedsagota0a1fhni5198o1uatl.png" />
          <img src="//qnm.hunliji.com/o_1dedsagot1rk1pe71g2d43f1kdem.png" />
          <img src="//qnm.hunliji.com/o_1dedsagot13o21801j4cap81ssan.png" />
          <img src="//qnm.hunliji.com/o_1dedsagot1ct8ped1h2oi8j1cgto.png" />
          <img src="//qnm.hunliji.com/o_1dedsagou6mpviv1cgd2vq1uqkp.png" />
          <img src="//qnm.hunliji.com/o_1dedsagoutahku31bp2ptf1g75q.png" />
          <img src="//qnm.hunliji.com/o_1dedsagou68t9mm1fvub0r1luvr.png" />
          <img src="//qnm.hunliji.com/o_1dedsagou1v1haj012nkqvok1cs.png" />
          <img src="//qnm.hunliji.com/o_1dedsagoudrhq6l15pnj5dlk0t.png" />
          <img src="//qnm.hunliji.com/o_1dedsagoujir1tqk6jp19vc162u.png" />
          <img src="//qnm.hunliji.com/o_1dedsagou7tt3r0sj8ve2hgv.png" />
        </div>
      </HeaderView>
    )
  }
}
